import BasicLayout from '@/layouts/basic-layout'

const prefix = 'storage-manage-owner-manage-'
export default [
  {
    path: '/storage-manage/owner-manage',
    redirect: {name: `${prefix}index`},
    component: BasicLayout,
    children: [
      {
        path: 'index',
        name: `${prefix}index`,
        meta: {title: '业主管理'},
        component: () => import('@/pages/storage-manage/owner-manage/index')
      },
      {
        path: 'detail-edit/:id',
        name: `${prefix}edit`,
        auth: ['hidden'],
        meta: {cache: true, title: '业主管理编辑'},
        component: () => import('@/pages/storage-manage/owner-manage/detail-edit')
      },

      {
        path: 'detail-view/:id',
        name: `${prefix}view`,
        auth: ['hidden'],
        meta: {title: '业主管理详情'},
        component: () => import('@/pages/storage-manage/owner-manage/detail-view')
      }
    ]
  }
]
